// in src/posts.js
import React, { Component } from 'react';
import {BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, Typography, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import Dropzone from 'react-dropzone'
import inputUploadField from '../mui/field/UploadField';
import InputUploadInput from '../mui/field/UploadInput';
import { RichTextInput } from 'ra-input-rich-text';
import onDrop from '../mui/field/onDrop';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const infoMessage = (
    <div style={{ marginBottom: '16px', color: 'gray' }}>
      Solo se permiten formatos de imagen PNG.
    </div>
);

export const PayprizeHomeList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar Informativa HOME">
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.idsection}
                    secondaryText={record => record.descriptionsHome}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="idsection" label="ID Sección" />
                    <ImageField source="coverHome" label="Portada" />
                    <RichTextField source="descriptionsHome" label="Descripción" />
                    <TextField source="urlHome" label="URL" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

const PayprizeHomeName = ({ record }) => {
    return <span>Plan de premios Home {record ? `"${record.id}"` : ''}</span>;
};

export const PayprizeHomeEdit = (props) => (
    <Edit title="Editar Reclamar Premios" {...props}>
        <SimpleForm>
            <TextInput source="id" disabled />
            <TextInput source="idsection" label="ID Sección" validate={[Validators.required, Validators.number]}/>
            <InputUploadInput source="coverHome" label="Portada" validate={[Validators.required, Validators.fileExtension]}/>
            {infoMessage}
            <RichTextInput source="descriptionsHome" label="Descripción" isRequired={true} validation={{ required: true }}/>
            <TextInput source="urlHome" label="URL" validate={[Validators.required]}/>
        </SimpleForm>
    </Edit>
);

export const PayprizeHomeCreate = (props) => (
    <Create {...props} title="Crear Reclamar Premios">
        <SimpleForm >
            <TextInput source="idsection" label="ID Sección" validate={[Validators.required, Validators.number]}/>
            <InputUploadInput source="coverHome" label="Portada" validate={[Validators.required, Validators.fileExtension]}/>
            {infoMessage}
            <RichTextInput source="descriptionsHome" label="Descripción" isRequired={true} validation={{ required: true }}/>
            <TextInput source="urlHome" label="URL" validate={[Validators.required]}/>
        </SimpleForm>
    </Create>
);

export const PayprizeHomeShow = (props) => (
    <Show title="Ver Reclamar Premios" {...props}>
        <SimpleShowLayout>
            <TextField source="idsection" label="ID Sección"/>
            <ImageField source="coverHome" label="Portada"/>
            <RichTextField source="descriptionsHome" label="Descripción"/>
            <TextField source="urlHome"/>
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
